import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss'],
})
export class ValidationErrorComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() validationMessages;
  @Input() controlName;

  constructor() {}

  ngOnInit() {}
}
